<template>
    <v-layout wrap>
        <v-navigation-drawer absolute permanent right width="500">
            <v-list class="pa-1">
                <v-list-item>
                    <v-list-item-avatar>
                        <img :src="img">
                    </v-list-item-avatar>
                    <v-list-item-content>
                        <v-list-item-title class="headline">{{ titleName }}</v-list-item-title>
                    </v-list-item-content>
                    <v-btn icon @click.native="closePanel()">
                        <v-icon color="grey lighten-1">mdi-close</v-icon>
                    </v-btn>
                </v-list-item>
            </v-list>

            <v-list class="pt-0" dense flat >
                <v-divider></v-divider>
                <v-card outlined>
                    <v-card-text>
                        <v-text-field 
                                v-model="value.name" 
                                label="Relation Name"
                                required
                                autofocus
                        ></v-text-field>
                        <v-select 
                                v-model="value.relationType"
                                :items="relationTypes"
                                item-text="name"
                                item-value="type"
                                label="Relation Type"
                        ></v-select>

                        <div v-if="value.relationType.includes('Aggregation') || value.relationType.includes('Composition') || value.relationType.includes('Association')">
                            <v-select 
                                    v-model="value.sourceMultiplicity"
                                    :items="multiplicityList"
                                    label="Source Multiplicity"
                            ></v-select>
                            <v-select 
                                    v-model="value.targetMultiplicity"
                                    :items="multiplicityList"
                                    label="Target Multiplicity"
                            ></v-select>
                        </div>

                        <v-text-field 
                                v-model="value.fromLabel"
                                label="Source Role"
                        ></v-text-field>
                        <v-text-field 
                                v-model="value.toLabel"
                                label="Target Role"
                        ></v-text-field>
                    </v-card-text>
                </v-card>
            </v-list>
        </v-navigation-drawer>
    </v-layout>

</template>

<script>
    import UMLPropertyPanel from '../UMLPropertyPanel'

    export default {
        mixins: [UMLPropertyPanel],
        name: 'uml-relation-panel',
        components: {},
        data: function () {
            return {
                relationTypes: [
                    {
                        name: 'Association',
                        type: 'org.uengine.uml.model.Association'
                    },
                    {
                        name: 'Aggregation',
                        type: 'org.uengine.uml.model.Aggregation'
                    },
                    {
                        name: 'Generalization',
                        type: 'org.uengine.uml.model.Generalization'
                    },
                    {
                        name: 'Composition',
                        type: 'org.uengine.uml.model.Composition'
                    },
                ],
                multiplicityList: [ '1', '1..n', '0..n', '0..1' ],
            }
        },
        computed: {
        },
        created: function () {
            var me = this
        },
        methods:{
        },
    }
</script>
